/**
 * Constants and configuration for UploadLoaderModal
 * 
 * Centralized configuration values for better maintainability
 */

// Timeout and polling configuration
export const PUSHER_TIMEOUT_MS = 180 * 1000; // 3 minutes timeout before falling back (increased from 90s)
export const FALLBACK_POLL_INTERVAL_MS = 10 * 1000; // Poll every 10 seconds as fallback (decreased from 30s for faster updates)
export const COMPLETED_JOB_AUTO_CLEAR_MS = 30 * 1000; // 30 seconds for download
export const STATE_CLEAR_DELAY_MS = 1000; // 1 second delay for UI state clearing

// UI configuration
export const SCROLL_THRESHOLD_PX = 50; // 50px threshold for "near bottom"
export const MODAL_ANIMATION_TIMEOUT_MS = 300; // Modal fade animation
export const STEP_ANIMATION_BASE_MS = 300; // Base animation time for steps
export const STEP_ANIMATION_INCREMENT_MS = 100; // Increment per step

// Cache configuration  
export const COMPLETED_JOB_CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes cache
export const MAX_CACHE_SIZE = 1000; // Max cached jobs

// File and content limits
export const MAX_FILE_SIZE_MB = 60; // Maximum file size in MB
export const MAX_FILES = 50; // Maximum number of files

// Step management
export const DEFAULT_STEP_ID_PREFIX = 'step-';
export const UPLOAD_STEP_ID = 'upload-files';
export const INITIAL_STEP_LABEL = 'Uploading files...';

// Modal sizing breakpoints
export const MODAL_BREAKPOINTS = {
  xs: "100%",
  sm: 600,
  md: 720,
  lg: "80%", // For document preview
} as const;

export const MODAL_MAX_WIDTHS = {
  default: "720px",
  preview: "1200px",
} as const;

// Color scheme
export const COLORS = {
  primary: '#223343',
  primaryHover: '#1e293b',
  error: '#dc2626',
  success: '#10b981',
  processing: '#3b82f6',
  warning: '#92400e',
  disabled: '#9ca3af',
  border: '#e5e7eb',
  background: '#fafafa',
} as const;

// Chip colors for status indicators
export const STATUS_CHIP_COLORS = {
  live: {
    backgroundColor: '#dcfce7',
    color: '#166534',
    borderColor: '#bbf7d0',
  },
  backup: {
    backgroundColor: '#fef3c7',
    color: '#92400e',
    borderColor: '#fde68a',
  },
  error: {
    backgroundColor: '#fde8e8',
    color: '#991b1b',
    borderColor: '#fecaca',
  },
  completed: {
    backgroundColor: '#dbeafe',
    color: '#1e40af',
    borderColor: '#93c5fd',
  },
} as const;

// Default messages
export const DEFAULT_MESSAGES = {
  processing: "Your documents are being analyzed and processed",
  completed: "Your document has been successfully processed and is ready for download.",
  error: "An error occurred while processing your documents",
  downloadFailed: "Failed to download file.",
  jobNotFound: "Job not found or no longer exists",
  clearingState: "Clearing...",
  close: "Close",
  downloadDocument: "Download Document",
  downloading: "Downloading...",
} as const;

// Tab configuration
export const TAB_INDICES = {
  PROCESSING_STEPS: 0,
  DOCUMENT_PREVIEW: 1,
} as const; 